import { useEffect, useState } from 'react'
import { toastQueue, type ToastItem } from './toastQueue'
import { ToastView } from './ToastView'
import styles from './Toast.module.scss'

/**
 * Mount once at the app root. Subscribes to `toastQueue` and renders a
 * fixed-position stack of high-contrast toasts that auto-dismiss after their
 * timeout.
 */
export function ToastContainer() {
  const [items, setItems] = useState<ToastItem[]>([])
  useEffect(() => toastQueue.subscribe(setItems), [])

  if (items.length === 0) return null
  return (
    <div
      className={styles.container}
      role="region"
      aria-live="polite"
      aria-label="Notifications"
    >
      {items.map((t) => (
        <ToastView
          key={t.id}
          variant={t.variant ?? 'info'}
          title={t.title}
          message={t.message}
          contrast="high"
          onDismiss={() => toastQueue.dismiss(t.id)}
        />
      ))}
    </div>
  )
}

export default ToastContainer
